import { render } from "./TickerHorarios.vue?vue&type=template&id=78d90aca&scoped=true"
import script from "./TickerHorarios.vue?vue&type=script&lang=js"
export * from "./TickerHorarios.vue?vue&type=script&lang=js"

import "./TickerHorarios.vue?vue&type=style&index=0&id=78d90aca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d90aca"]])

export default __exports__